<template>
    <div v-if="products.length > 0">
        <h2 class="quiz__campaign__endpoint-title">{{ content.title }}</h2>
        <div class="quiz__campaign__endpoint-related-carousel swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(product, product_key) in products" v-if="product.featured_image !== null" :key="product_key" :index="'product' + product_key" :product="product" class="swiper-slide carousel-item">
                    <div class="product-container">
                        <div class="product-image" :style="'background-image: url('+ product.featured_image.url.replace(' ','%20')+')'">
                            <img :src="product.featured_image.url" :alt="product.featured_image.alt_text" />
                        </div>
                        <h3>{{ product.name }}</h3>
                        <p class="product-model">{{ product.model }}</p>
                        <review-block v-if="showReviews" :rating="product.reviews_rating"></review-block>
                        <p class="price">&pound;{{ product.display_price }}</p>
                    </div>
                    <div class="quiz__campaign__endpoint-product-actions">
                        <a class="quiz__campaign__endpoint-button" :href="product.links.view">View</a>
                        <a v-if="showBuy && product.links.buy !== null" class="quiz__campaign__endpoint-button quiz__campaign__endpoint-button-primary basket-add" :href="product.links.buy">Buy</a>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>

import ReviewBlock from './reviews-block';

export default {
    props: ['shopconfig','content'],
    components: {
        ReviewBlock
    },
    methods: {
        backgroundImage( image ) {
            return 'background-image: url(' + image + ');';
        },
        initRelatedSlider() {
            let vm = this;

            let options = {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                initialSlide: 1,
                centerInsufficientSlides: true,
                loop: false,
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 15,
                speed: 500,
                centeredSlides: false,
                autoplay: false,
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 15
                    }
                }
            }

            vm.swiper = new Swiper('.quiz__campaign__endpoint-related-carousel', options);
        }
    },
    mounted() {
        let vm = this;
        this.products = this.content.data;
        $(document).ready(function(){
            vm.initRelatedSlider();
            setTimeout(()=>{
                vm.swiper.update();
            },500);
        });
    },
    computed: {
        showBuy: function() {
            return (this.shopconfig.ecommerce.enabled == 1) ? true : false;
        },
        showReviews: function() {
            return (this.shopconfig.bazaarvoice.enabled == 1) ? true : false;
        }
    },
    data() {
        return {
            products: [],
            swiper: null
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/related-products.vue